"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFactContentTextProperty = exports.factContentTextPropertyDefinition = void 0;
exports.factContentTextPropertyDefinition = {
    view: { label: 'Fact Text' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 120,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'fact-content-text',
};
const isFactContentTextProperty = (prop) => {
    return prop.name === exports.factContentTextPropertyDefinition.name;
};
exports.isFactContentTextProperty = isFactContentTextProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdC1jb250ZW50LXRleHQucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9mYWN0LWNvbnRlbnQtdGV4dC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGlDQUFpQyxHQUFHO0lBQy9DLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxXQUFXLEVBQUU7SUFDNUIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsR0FBRztTQUNkO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLG1CQUFtQjtDQUNNLENBQUE7QUFJMUIsTUFBTSx5QkFBeUIsR0FBRyxDQUFDLElBQWtCLEVBQW1DLEVBQUU7SUFDL0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHlDQUFpQyxDQUFDLElBQUksQ0FBQTtBQUM3RCxDQUFDLENBQUE7QUFGWSxRQUFBLHlCQUF5Qiw2QkFFckMifQ==